export const cdmChecklistItemNewObservationRoute =
  '/checklist-item/:checklistItemId/observation';

export const cdmChecklistItemObservationDetailsRoute =
  '/checklist-item/:checklistItemId/observation/:observationExternalId';

export const cdmChecklistItemObservationListRoute =
  '/checklist-item/:checklistItemId/observations';

export const getCdmChecklistItemObservationPath = (
  checklistItemId: string,
  observationExternalId?: string
) =>
  observationExternalId
    ? `/checklist-item/${encodeURIComponent(checklistItemId)}/observation/${encodeURIComponent(observationExternalId)}`
    : `/checklist-item/${encodeURIComponent(checklistItemId)}/observation`;

export const getCdmChecklistItemObservationListPath = (
  checklistItemId: string
) => `/checklist-item/${encodeURIComponent(checklistItemId)}/observations`;
